import { render, staticRenderFns } from "./list-page-header.html?vue&type=template&id=7a547d80&scoped=true&"
import script from "./list-page-header.ts?vue&type=script&lang=js&"
export * from "./list-page-header.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a547d80",
  null
  
)

export default component.exports